"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Yahoo = function Yahoo(props) {
  return _react2.default.createElement(
    "svg",
    _extends({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement(
      "g",
      { transform: "translate(3 3)", fill: "#000", fillRule: "nonzero" },
      _react2.default.createElement("ellipse", { cx: 9.429, cy: 11.178, rx: 1, ry: 1 }),
      _react2.default.createElement("path", { d: "M10.02 0L5.79 6.813l.082 5.023c-.616-.156-1.19-.156-1.724 0l.123-5.023L0 0l.205.078a3.517 3.517 0 0 0 1.56 0h.124C2.341.934 5.01 5.1 5.01 5.1L8.172.078h.123C9.158.31 10.02 0 10.02 0zm.041 9.539l-.287-.117-.329.039.904-8.488c.164-1.401 1.97-.817 1.601.234l-1.889 8.332z" })
    )
  );
};

exports.default = Yahoo;
Yahoo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Yahoo"
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Yahoo.js
// module id = 633
// module chunks = 0